import API from "../api/api";

export const getPackages = async () => {
    try {
        const response = await API.post("/priceSection/list", {
            sEcho: 1,
            iDisplayStart: 0,
            iDisplayLength: 100,
            sSearch: "",
            iSortCol_0: 0,
            sSortDir_0: "asc",
            aaSorting: [[0, "asc"]],
            bRegex: false,
            bRegex_0: false,
            bSearchable_0: true,
            bSortable_0: true,
            mDataProp_0: 0
        });
        
        // Return the data array from the response. 
        // Backend returns: { draw, recordsTotal, recordsFiltered, data: [...] }
        return response.data.data || []; 
    } catch (error) {
        console.error("Error fetching packages data:", error);
        throw error;
    }
};
